import type { SVGProps } from 'react';

const Rotate2 = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.58232 4.582C6.46985 2.69447 9.53014 2.69447 11.4177 4.582C13.3052 6.46953 13.3052 9.52981 11.4177 11.4173C9.53014 13.3049 6.46985 13.3049 4.58232 11.4173C4.15979 10.9948 3.83184 10.5135 3.59848 9.99974"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.16669 12.8327V10.4993C3.16669 10.1311 3.46517 9.83267 3.83335 9.83267H6.16669"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Rotate2;
